import {
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  EDIT_PROFILE,
  CANCEL_EDIT_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  PROFILE_ERRORS,
} from '../constants/action-types/profile';
import { initialStateProfile } from '../store/models/profile';

export default function profileReducer(state = initialStateProfile, action) {
  switch (action.type) {
    case GET_PROFILE:
      return {
        ...state,
        profile: {},
        isLoading: true,
      };
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.data,
        isLoading: false,
      };
    case EDIT_PROFILE:
      return {
        ...state,
        isEditing: true,
      };
    case CANCEL_EDIT_PROFILE:
      return {
        ...state,
        isEditing: false,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        isEditing: false,
        profile: action.data,
      };
    case PROFILE_ERRORS:
      return {
        ...state,
        isEditing: false,
        isLoading: false,
      };
    default:
      return state;
  }
}
